module.exports = __webpack_public_path__ + "static/img/活动策划案例01.69eacc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/活动策划案例01.png
// module id = Lf2v
// module chunks = 3